import { useEffect, useState } from 'react';
import { Button, Card, Modal, Table } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { FaPen } from 'react-icons/fa';
import CotisationChoixCreate from './CotisationChoixCreate';

const CotisationChoix = ({ getCotisation }) => {
    const [choix, setChoix] = useState([]);
    const [cotisationIdSel, setCotisationIdSel] = useState('');
    const [showChoix, setShowChoix] = useState(false);
    const [maxordre, setMaxordre] = useState(0);

    const url = localStorage.getItem('url');
    const cotisations = JSON.parse(localStorage.getItem('cotisations')) || [];

    useEffect(() => {
        getChoix();
    }, []);

    const getChoix = () => {
        console.log('getChoix');
        fetch(`${url}GetChoix/`)
            .then(response => response.json())
            .then(data => {
                setChoix(data.data);

                let filtered = data.data.filter(e => e.cotisation_id === cotisationIdSel);
                setMaxordre(getMaxOrdre(filtered));
                setShowChoix(false);
            })
            .catch(error => console.error('Erreur:', error));
    }

    const selectId = (id) => {
        setCotisationIdSel(id);
        let filtered = choix.filter(el => el.cotisation_id === id);
        console.log('selectId :', id, filtered);
        setMaxordre(getMaxOrdre(filtered));
    }

    const rename = (row) => {
        //ajoute a types le retour du prompt
        const libelle = prompt('Nouveau libelle pour les choix de la cotisation', row.libelle);
        if (libelle) {
            fetch(`${url}UpdateChoixCotisation/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ id: row.id, libelle: libelle }),
            })
                .then((response) => response.json())
                .then((data) => {
                    getCotisation();
                })
                .catch((error) => {
                    console.error('Erreur:', error);
                });
        }
    }

    const nouveauChoixCotisation = () => {
        //ajoute a types le retour du prompt
        const libelle = prompt('Nouveau libelle pour les choix de la cotisation');
        if (libelle) {
            fetch(`${url}CreateChoixCotisation/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ libelle: libelle }),
            })
                .then((response) => response.json())
                .then((data) => {
                    setCotisationIdSel(data.data.find(e => e.libelle === libelle).id);
                    // Traitez la réponse du serveur si nécessaire
                })
                .catch((error) => {
                    console.error('Erreur:', error);
                });
        }
    }

    const getMaxOrdre = (choix) => {
        let max = 0;
        choix.forEach(e => {
            if (e.ordre > max) {
                max = e.ordre;
            }
        });
        return max;
    }



    const columnsChoix = [
        { name: 'Référence', width: '120px', selector: row => row.reference, sortable: true, wrap: true },
        { name: 'Libellé', selector: row => row.libelle, sortable: true, wrap: true },
        {
            name: 'Actions', width: '80px', cell: row => (<>
                <Button variant='secondary' onClick={() => rename(row)}><FaPen /></Button>
            </>),
        },
    ];

    const ajouteChoix = (id) => {
        selectId(id);
        setShowChoix(true);
    }

    const ExpandedComponent = ({ data }) => {

        let id = data.id;
        let myChoix = [...choix].filter(el => el.cotisation_id === id);
        setCotisationIdSel(id);
        // setChoixFiltered(myChoix);

        console.log('id :', id, ...myChoix);

        return <Card>
            <Card.Header>Choix de cotisation</Card.Header>
            {/* <Card.Body> */}
            <Table striped bordered hover style={{ margin: 'auto', }}>
                <thead>
                    <tr>
                        {/* <th>Ordre</th> */}
                        <th>Libelle</th>
                        <th>Montant</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        myChoix.map((e) => (
                            <tr>
                                {/* <td>{e.ordre}</td> */}
                                <td>{e.libelle}</td>
                                <td>{e.montant}&nbsp;€</td>
                            </tr>
                        ))
                    }
                </tbody>
            </Table>
            <Button variant="outline-primary" onClick={() => ajouteChoix(id)} size='lg'>+</Button>

        </Card>
            // <pre>{JSON.stringify(data.choix, null, 2)}</pre>
            ;
    }

    const handleRowClick = (row) => {
        console.log('row :', row);
        // setCotisationIdSel(row.id);
        selectId(row.id);
    }

    return (
        <div>

            <h1>Cotisation<Button variant="danger" onClick={nouveauChoixCotisation}>+</Button></h1>

            <DataTable
                columns={columnsChoix}
                data={cotisations}
                pagination={true}
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                highlightOnHover
                defaultSortField="id"
                defaultSortAsc={false}
                subHeaderAlign="left"
                noHeader={true}
                paginationComponentOptions={{
                    rowsPerPageText: 'Lignes par page:',
                }}
                expandableRows
                expandableRowsComponent={ExpandedComponent}
                onRowClicked={handleRowClick}
            />

            <Modal size="xl" show={showChoix} onHide={() => setShowChoix(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Nouveau choix</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CotisationChoixCreate choixCotisationIdSel={cotisationIdSel} getChoix={getChoix} maxordre={maxordre} />
                </Modal.Body>
            </Modal>

        </div>
    );
}

export default CotisationChoix;
